import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import {
  InlineValueWrapper,
  PrincipalInfoWrapper,
  SecondaryInfoWrapper,
  ImportantInfoWrapper,
  InlineBreakValueWrapper,
  BoxWrapper
} from '../FolderAllocateResponsibleStyles';
import { LabelImportant, AssignmentInd, Info } from '@mui/icons-material';
import { Card } from '@totalsoft/rocket-ui';

const FolderAllocateResponsibleListItem = ({ t, onAllocateFolders, item, selectedFolderList }) => {
  const offerNumbersLength = item.offerNumbers?.split(',').length;

  const handleCheckBoxChange = useCallback(
    event => {
      onAllocateFolders(item, event.target.checked);
    },
    [item, onAllocateFolders]
  );

  return (
    <Card disablePadding sx={{ px: 2, py: 1 }}>
      <Grid container alignItems='center'>
        <Grid item>
          <FormControlLabel
            control={
              <Checkbox
                id={'folderAllocateResponsible_isSelected'}
                checked={selectedFolderList.find(f => f.documentId === item.documentId && f.siteId === item.siteId) ? true : false || false}
                onChange={handleCheckBoxChange}
                color='primary'
                name='isSelected'
                size='small'
              />
            }
          />
        </Grid>
        <Grid item container xs justifyContent='space-between'>
          <PrincipalInfoWrapper item container xs spacing={1}>
            <Grid item>
              <BoxWrapper>
                <LabelImportant />
                <strong>{t('FolderAllocateResponsible.FolderNumber')}</strong>{' '}
                <ImportantInfoWrapper>{item.folderNumber}</ImportantInfoWrapper>
              </BoxWrapper>
            </Grid>
            {!!item.offerNumbers?.trim() && (
              <Grid item>
                <BoxWrapper>
                  <LabelImportant />
                  <strong>
                    {offerNumbersLength > 1 ? t('FolderAllocateResponsible.OfferNumbers') : t('OfferResponsibleChange.OfferNumber')}
                  </strong>{' '}
                  <InlineValueWrapper>{item.offerNumbers}</InlineValueWrapper>
                </BoxWrapper>
              </Grid>
            )}
            {item.clientName && (
              <Grid item>
                <BoxWrapper>
                  <AssignmentInd />
                  <InlineBreakValueWrapper>{item.clientName}</InlineBreakValueWrapper>
                </BoxWrapper>
              </Grid>
            )}
          </PrincipalInfoWrapper>
          <SecondaryInfoWrapper item container spacing={1} xs>
            <Grid item>
              <BoxWrapper>
                <Info />
                <InlineValueWrapper>{item.stateName}</InlineValueWrapper>
              </BoxWrapper>
            </Grid>
            <Grid item>
              <BoxWrapper>
                <Info />
                <InlineValueWrapper>{t('OfferResponsibleChange.Responsible')}</InlineValueWrapper>{' '}
                <InlineBreakValueWrapper>{item.responsibleName}</InlineBreakValueWrapper>
              </BoxWrapper>
            </Grid>
          </SecondaryInfoWrapper>
        </Grid>
      </Grid>
    </Card>
  );
};

FolderAllocateResponsibleListItem.propTypes = {
  t: PropTypes.func.isRequired,
  onAllocateFolders: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  selectedFolderList: PropTypes.array.isRequired
};

export default compose(withTranslation())(FolderAllocateResponsibleListItem);
